import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "partner-relations" }
const _hoisted_2 = { class: "relation-groups" }
const _hoisted_3 = { class: "relation-group" }
const _hoisted_4 = { class: "relation-list" }
const _hoisted_5 = { class: "relation-type partner" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "empty-related-tasks"
}
const _hoisted_8 = { class: "relation-group" }
const _hoisted_9 = { class: "relation-list" }
const _hoisted_10 = {
  key: 0,
  class: "empty-related-tasks"
}
const _hoisted_11 = { class: "relation-create" }
const _hoisted_12 = { class: "relation-type-tabs" }
const _hoisted_13 = { class: "entity-search" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = {
  key: 0,
  class: "entity-results"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "create-task-hint"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = _resolveComponent("RouterLink")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("header", null, [
          _cache[4] || (_cache[4] = _createElementVNode("div", null, [
            _createElementVNode("span", { class: "relation-icon partner" }, "P"),
            _createElementVNode("strong", null, "Партнёры")
          ], -1 /* CACHED */)),
          _createElementVNode("small", null, _toDisplayString($setup.partnerRows.length), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.partnerRows, (row) => {
            return (_openBlock(), _createElementBlock("div", {
              key: row.key,
              class: "relation-row"
            }, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(row.label), 1 /* TEXT */),
              _createVNode(_component_RouterLink, {
                to: row.path
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.title), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
              _createElementVNode("small", null, _toDisplayString(row.subtitle || "Без категории"), 1 /* TEXT */),
              _createElementVNode("button", {
                type: "button",
                title: "Удалить связь",
                onClick: $event => ($setup.remove(row.linkId))
              }, "×", 8 /* PROPS */, _hoisted_6)
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          (!$setup.partnerRows.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Связанных партнёров нет"))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("section", _hoisted_8, [
        _createElementVNode("header", null, [
          _cache[5] || (_cache[5] = _createElementVNode("div", null, [
            _createElementVNode("span", { class: "relation-icon task" }, "✓"),
            _createElementVNode("strong", null, "Задачи")
          ], -1 /* CACHED */)),
          _createElementVNode("small", null, _toDisplayString($setup.taskRows.length), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.taskRows, (row) => {
            return (_openBlock(), _createElementBlock("div", {
              key: row.key,
              class: "relation-row"
            }, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "relation-type task" }, "Задача", -1 /* CACHED */)),
              _createVNode(_component_RouterLink, {
                to: row.path
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.title), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
              _createElementVNode("small", null, _toDisplayString(row.subtitle), 1 /* TEXT */),
              _cache[7] || (_cache[7] = _createElementVNode("span", null, null, -1 /* CACHED */))
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          (!$setup.taskRows.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Связанных задач нет"))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass({active:$setup.relationType==='CrmTask'}),
          onClick: _cache[0] || (_cache[0] = $event => ($setup.changeType('CrmTask')))
        }, "Связать задачу", 2 /* CLASS */),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass({active:$setup.relationType==='Partner'}),
          onClick: _cache[1] || (_cache[1] = $event => ($setup.changeType('Partner')))
        }, "Связать партнёра", 2 /* CLASS */)
      ]),
      _createElementVNode("form", {
        class: "relation-picker",
        onSubmit: _withModifiers($setup.addRelation, ["prevent"])
      }, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.kind) = $event)),
          "aria-label": "Тип связи"
        }, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("option", { value: "related" }, "Связана с", -1 /* CACHED */),
          _createElementVNode("option", { value: "blocks" }, "Блокирует", -1 /* CACHED */)
        ]))], 512 /* NEED_PATCH */), [
          [_vModelSelect, $setup.kind]
        ]),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.query) = $event)),
            placeholder: $setup.relationType === 'CrmTask' ? 'Найти или создать задачу…' : 'Найти партнёра…',
            onInput: $setup.scheduleSearch
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_14), [
            [_vModelText, $setup.query]
          ]),
          ($setup.results.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.results, (item) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: `${item.type}-${item.id}`,
                    type: "button",
                    onClick: $event => ($setup.select(item))
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(item.title), 1 /* TEXT */),
                    _createElementVNode("small", null, _toDisplayString($setup.relationType === "CrmTask" ? "Задача" : "Партнёр") + " · " + _toDisplayString(item.subtitle), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_16))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("button", {
          class: "primary",
          disabled: !$setup.query.trim() || $setup.saving || $setup.searching || (!$setup.selected && ($setup.results.length || $setup.relationType === 'Partner'))
        }, _toDisplayString($setup.saving ? "…" : $setup.selected ? "Связать" : $setup.results.length ? "Выберите" : $setup.relationType === "Partner" ? "Выберите партнёра" : "Создать задачу"), 9 /* TEXT, PROPS */, _hoisted_17)
      ], 32 /* NEED_HYDRATION */),
      ($setup.query && !$setup.selected && !$setup.results.length && !$setup.searching)
        ? (_openBlock(), _createElementBlock("small", _hoisted_18, _toDisplayString($setup.relationType === "CrmTask" ? "Задача не найдена — будет создана с таким названием" : "Партнёр не найден"), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}